<template>
  <layout-main-inner title="发货管理">
    <div slot="action">
      <export-express-btn :loading="loading" />
    </div>
    <layout-card-wrap
      v-loading="loading"
      hasHeaderSlot>
      <template slot="form">
        <el-form
          label-width="80px"
          @submit.native.prevent>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="发货状态:">
                <status-select
                  v-model="config.status"
                  style="width: 100%"
                  :callback="()=> { handleCurrentChange(1) }" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="物流类型:">
                <trans-type-select
                  v-model="config.transType"
                  style="width: 100%"
                  :callback="()=> { handleCurrentChange(1) }" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="打单状态:">
                <print-status-select
                  v-model="config.printStatus"
                  style="width: 100%"
                  :callback="()=> { handleCurrentChange(1) }" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="发货方式:">
                <el-select
                  v-model="config.outType"
                  placeholder="请选择发货方式"
                  @change="()=> {handleCurrentChange(1)}">
                  <el-option
                    :key="1"
                    label="全部"
                    :value="null">
                  </el-option>
                  <el-option
                    :key="2"
                    label="正常发货"
                    :value="0">
                  </el-option>
                  <el-option
                    :key="3"
                    label="空包发货"
                    :value="1">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="发货仓库:">
                <ent-warehouse-auto-select
                  v-model="config.warehouseNo"
                  :callback="() => {handleCurrentChange(1)}" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="订单号:">
                <el-input
                  v-model="config.bizOrderCode"
                  clearable=""
                  placeholder="请输入订单号"
                  @keyup.enter.native="handleCurrentChange(1)">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="发货单号:">
                <el-input
                  v-model="config.code"
                  clearable=""
                  placeholder="请输入发货单号"
                  @keyup.enter.native="handleCurrentChange(1)"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="收件人:">
                <el-input
                  v-model="config.receiverName"
                  clearable=""
                  placeholder="请输入姓名或手机号"
                  @keyup.enter.native="handleCurrentChange(1)"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="快递单号:">
                <el-input
                  v-model.trim="config.logisticsCode"
                  clearable=""
                  placeholder="请输入快递单号">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="">
                <el-button
                  type="primary"
                  @click="handleCurrentChange(1)">查询</el-button>
                <!-- <el-button
                  :disabled="multipleSelection.length === 0"
                  style="margin-left:10px"
                  type="success"
                  @click="bacthPrint">打印单据 <span v-if="multipleSelection.length > 0">(共{{ multipleSelection.length }}项)</span></el-button> -->
                <no-pager-checkbox
                  v-model="noPager"
                  :pagerNo="pagerNo"
                  :pagerYes="pagerYes"
                  style="margin-left: 5px" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="6">
              <el-form-item label="批量模式:">
                <el-select
                  v-model="batchType"
                  placeholder="请选择"
                  @change="batchTypeChange">
                  <el-option
                    v-for="item in batchTypeList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="18">
              <el-button
                :disabled="multipleSelection.length === 0 || batchType === 2"
                type="success"
                @click="bacthPrint">打印单据 <span v-if="multipleSelection.length > 0 && batchType === 1">(共{{ multipleSelection.length }}项)</span></el-button>
              <!-- <el-button
                :disabled="multipleSelection.length === 0 || batchType === 1"
                type="success"
                @click="bacthPrint">打印面单<span v-if="multipleSelection.length > 0 && batchType === 2">(共{{ multipleSelection.length }}项)</span></el-button> -->
              <batch-express-btn
                :disabled="multipleSelection.length === 0 || batchType === 1"
                :showCount="multipleSelection.length > 0 && batchType === 2"
                :selection="multipleSelection"
                :callback="fetchList" />
              <!-- <batch-tally-order-btn :selection="multipleSelection" /> -->
            </el-col>
          </el-row>
        </el-form>
      </template>
      <el-table
        ref="tableMuti"
        border
        :row-style="rowStyle"
        :data="list"
        @selection-change="handleSelectionChange">
        <el-table-column
          fixed="left"
          :selectable="selectableFn"
          type="selection"
          width="40">
        </el-table-column>
        <el-table-column
          label="发货单号"
          min-width="200"
          fixed="left"
          :resizable="false"
          prop="code">
          <template slot-scope="{row}">
            <link-route
              v-if="row.type === 21"
              :link-to="`/orders-detail?salesOrderId=${row.bizOrderId}&code=${row.bizOrderCode}&activeName=2`">
              {{ row.code }}
            </link-route>
            <link-route
              v-if="row.type === 23"
              :link-to="`/transfer-stock-detail?allocateOrderId=${row.bizOrderId}&code=${row.bizOrderCode}&activeName=2`">
              {{ row.code }}
            </link-route>
            <span v-if="row.type !== 21 && row.type !== 23"></span>
            <el-tag
              v-if="row.combinedDeliveryNumber > 0"
              type="warning">已并单</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="订单号"
          :resizable="false"
          width="170"
          prop="bizOrderCode">
        </el-table-column>
        <el-table-column
          label="收件人"
          :resizable="false"
          min-width="220"
          prop="receiver">
        </el-table-column>
        <el-table-column
          label="仓库"
          :resizable="false"
          min-width="120"
          prop="warehouseNo">
          <template slot-scope="{row}">
            {{ row.warehouseNo | warehouseName() }}
          </template>
        </el-table-column>
        <el-table-column
          label="订单来源"
          width="90"
          :resizable="false">
          <template slot-scope="{row}">
            {{ row.orderSource | sourceName() }}
          </template>
        </el-table-column>
        <el-table-column
          label="出库类型"
          width="105"
          :resizable="false"
          prop="type">
          <template slot-scope="{row}">
            {{ row.type| outTypeName() }}
            <el-tag
              v-if="row.orderSource === 7"
              type="success">礼</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          label="发货方式"
          :resizable="false"
          width="75"
          prop="outType">
          <template slot-scope="{row}">
            <span v-if="row.outType === 0">正常发货</span>
            <span v-if="row.outType === 1">空包发货</span>
          </template>
        </el-table-column>
        <el-table-column
          label="发货状态"
          :resizable="false"
          width="75"
          prop="status">
          <template slot-scope="{row}">
            {{ row.status | outStatusName() }}
          </template>
        </el-table-column>
        <el-table-column
          label="物流模板"
          :resizable="false"
          min-width="160"
          prop="packageNum">
          <template slot-scope="{row}">
            <el-popover
              v-if="row.needInputWeightAndVolume === 1"
              placement="top-start"
              title="包裹信息"
              width="100"
              trigger="hover">
              <el-form
                label-width="45px"
                class="package-info">
                <el-form-item
                  label="体积:"
                  style="margin-bottom: 0">{{ row.volume || row.defaultVolume }}立方米</el-form-item>
                <el-form-item
                  label="重量:"
                  style="margin-bottom: 0">{{ row.volume || row.defaultWeight }}公斤</el-form-item>
              </el-form>
              <div slot="reference">
                <i class="el-icon-info"></i>
                <span>{{ row.expressCode | expressName() }}</span>
              </div>
            </el-popover>
            <span v-else>{{ row.expressCode | expressName() }}</span>
          </template>
        </el-table-column>
        <el-table-column
          label="物流类型"
          :resizable="false"
          width="75"
          prop="type">
          <template slot-scope="{row}">
            {{ row.transType | transTypeName() }}
          </template>
        </el-table-column>
        <el-table-column
          label="打单状态"
          :resizable="false"
          prop="printStatus"
          width="95">
          <template slot-scope="{row}">
            <span
              v-if="row.transType !== 3"
              :style="{color: row.printStatus === 9 ? 'red' : ''}">
              {{ row.printStatus | printStatusName() }}
              <!-- <el-tooltip
                v-if="row.printStatus === 9"
                effect="dark"
                :content="row.printErrorMsg"
                placement="top-start">
                <i
                  class="el-icon-question"
                  style="cursor:pointer"></i>
              </el-tooltip> -->
              <el-popover
                v-if="row.printStatus === 9"
                placement="top-start"
                title="错误信息"
                width="200"
                trigger="hover"
                :content="row.printErrorMsg">
                <i
                  slot="reference"
                  class="el-icon-question"
                  style="cursor:pointer"></i>
              </el-popover>
            </span>
          </template>
        </el-table-column>
        <el-table-column
          label="创建时间"
          :resizable="false"
          width="140">
          <template slot-scope="{row}">
            {{ row.createTime | dateformat() }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          :resizable="false"
          fixed="right"
          width="105">
          <template slot-scope="{row}">
            <template v-if="row.status !== 9">
              <el-dropdown>
                <el-button type="warning">
                  更多<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item
                    :disabled="!(row.status === 0 || row.status === 1)"
                    @click.native="outcancel(row)">撤销</el-dropdown-item>
                  <el-dropdown-item
                    :disabled="!(row.transType !== 3)"
                    @click.native="printWrap(row)">打印面单</el-dropdown-item>
                  <el-dropdown-item
                    :disabled="!(row.needInputWeightAndVolume === 1 && row.transType !== 3)"
                    @click.native="setweightandvolume(row)">设置包裹信息</el-dropdown-item>
                  <el-dropdown-item
                    :disabled="!(row.printStatus === 2)"
                    @click.native="getdeliverytrace(row)">查看物流信息</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <template slot="footer">
        <pagination-new
          v-if="!noPager"
          v-model="config"
          :total="total"
          :fetch="fetchList" />
      </template>
    </layout-card-wrap>
    <printer-select-modal ref="printer" />
    <set-weight-modal
      ref="weight"
      :callback="fetchList" />

    <delivery-trace-modal ref="trace" />
  </layout-main-inner>
</template>

<script>
import EntWarehouseAutoSelect from '../../components/business/ent-warehouse-auto-select.vue'
import { mapState } from 'vuex'
import StatusSelect from './status-select.vue'

import PrinterSelectModal from './busi/printer-select-modal.vue'
import SetWeightModal from './busi/set-weight-modal.vue'
import { getTemplateList } from './templateUtil/tmpl'
import PrintStatusSelect from './print-status-select.vue'
import NoPagerCheckbox from '../../components/no-pager-checkbox.vue'
import TransTypeSelect from './trans-type-select.vue'
import BatchExpressBtn from '../../components/batch-express-btn.vue'
import DeliveryTraceModal from './busi/delivery-trace-modal.vue'
import ExportExpressBtn from './export-express-btn.vue'
// import BatchTallyOrderBtn from '../../components/batch-tally-order-btn.vue'
const COLOR = ['oldlace', '#f0f9eb', 'rgb(217, 236, 255)', 'rgb(225, 243, 216)']
const COLOR_MAP = {}

export default {
  name: 'OutstockList',
  components: { ExportExpressBtn, DeliveryTraceModal, EntWarehouseAutoSelect, StatusSelect, PrintStatusSelect, PrinterSelectModal, SetWeightModal, NoPagerCheckbox, TransTypeSelect, BatchExpressBtn },
  data() {
    return {
      batchTypeList: [{ label: '打印单据', value: 1 }, { label: '打印面单', value: 2 }],
      batchType: 2,
      loading: false,
      noPager: false,
      config: {
        pageNum: 1,
        pageSize: 10,
        code: '',
        bizOrderCode: '',
        warehouseNo: null,
        status: 0,
        printStatus: null,
        typeList: [21, 23],
        outType: null,
        transType: null,
        receiverName: '',
        logisticsCode: ''
      },
      list: [],
      total: 0,
      multipleSelection: []
    }
  },
  computed: {
    ...mapState({
      userInfo: state => state.account.userInfo,
      query: state => state.common.query
    })
  },
  created() {
    if (this.query) {
      this.config = {
        ...this.config,
        ...this.query
      }
    }
  },
  activated() {
    this.fetchList()
  },
  mounted() {
    this.fetchList()
  },
  methods: {
    rowStyle({ row }) {
      if (row.combinedDeliveryNumber === 0 || !row.combinedDeliveryNumber) {
        return {}
      }
      if (COLOR_MAP[row.combinedDeliveryNumber]) {
        return {
          'background-color': COLOR_MAP[row.combinedDeliveryNumber]
        }
      }
      COLOR_MAP[row.combinedDeliveryNumber] = COLOR[0]
      const first = COLOR.shift()
      COLOR.push(first)
      return {
        'background-color': COLOR_MAP[row.combinedDeliveryNumber]
      }
    },
    getdeliverytrace(row) {
      this.$refs.trace.fetch({
        vendorId: row.parentOwnerCode,
        courierNumber: row.logisticsCode
      })
    },
    pagerNo() {
      this.config.pageSize = 1000000
      this.handleCurrentChange(1)
    },
    pagerYes() {
      this.config.pageSize = 10
      this.handleCurrentChange(1)
    },
    batchTypeChange() {
      this.$refs.tableMuti.clearSelection()
    },
    selectableFn(row) {
      if (this.batchType === 1) {
        return row.status !== 9
      }
      if (this.batchType === 2) {
        return row.status !== 9 && row.transType !== 3
      }
      return true
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    bacthPrint() {
      const list = getTemplateList(this.multipleSelection)
      console.log(list)
      this.$refs.printer.fetch(list)
    },
    setweightandvolume(row) {
      console.log(row)
      const { defaultVolume, volume, defaultWeight, weight, sendOrderId, code, expressCode } = row
      this.$refs.weight.fetch({
        volume: volume || defaultVolume,
        weight: weight || defaultWeight,
        sendOrderId, code, expressCode
      })
    },
    printWrap(row) {
      this.$confirm('是否打印面单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          if (row.printStatus === 0 || row.printStatus === 9) {
            this.expressprint(row, () => {
              this.printHtml(row)
            })
          } else {
            this.printHtml(row)
          }
        })
    },
    expressprint(row, cb) {
      this.loading = true
      this.$store.dispatch('outstock/expressprint', {
        payload: {
          printFlag: 1,
          orderIdList: [row.id],
          expressCode: row.expressCode,
          transType: row.transType
        },
        success: (res) => {
          this.loading = false
          this.fetchList()
          if (res.data.data.length === 0) {
            this.$message.error('打印失败')
            return
          }
          cb && cb()
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    printHtml(row) {
      this.loading = true
      this.$store.dispatch('outstock/sendlist', {
        payload: {
          pageNum: 1,
          pageSize: 1000,
          outOrderCode: row.code
        },
        success: (res) => {
          this.loading = false
          console.log(res)
          const list = []
          res.data.data.records.forEach(i => {
            const { logisticsCode: documentID, printTemplateSign: signature, vendorExpress, salesOrderCode } = i
            const templateURL = vendorExpress ? vendorExpress.templateUrl : ''
            const printingPlatform = vendorExpress ? vendorExpress.printingPlatform : ''
            list.push(...i.printTemplate.map(printData => ({ printData, documentID, signature, templateURL, printingPlatform, salesOrderCode })))
          })
          this.$refs.printer.fetch(list)
        },
        fail: () => {
          this.loading = false
        }
      })
    },
    outcancel(row) {
      this.$confirm('是否取消出库单?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.loading = true
          this.$store.dispatch('outstock/outcancel', {
            payload: {
              outOrderId: row.id
            },
            success: () => {
              this.loading = false
              this.fetchList()
            },
            fail: () => {
              this.loading = false
            }
          })
        })
    },
    handleCurrentChange(current) {
      this.config.pageNum = current
      this.fetchList()
    },
    fetchList() {
      this.loading = true
      this.$store.commit('common/setQuery', this.config)
      this.$store.dispatch('outstock/getoutlist', {
        payload: {
          ...this.config,
          excludePrintTemplate: true
        },
        success: (res) => {
          this.loading = false
          this.total = res.data.data.total
          this.list = res.data.data.records.map(i => {
            const sendOrderList = i.sendOrderList || []
            const sendOrder = sendOrderList[0] || {}
            const { receiverName, receiverMobile, receiverTel, logisticsCode, printErrorMsg } = sendOrder
            return {
              ...i,
              packageNum: sendOrder.packageNum,
              sendOrderId: sendOrder.id,
              needInputWeightAndVolume: sendOrder.needInputWeightAndVolume,
              defaultVolume: sendOrder.defaultVolume,
              defaultWeight: sendOrder.defaultWeight,
              volume: sendOrder.volume,
              weight: sendOrder.weight,
              receiver: `${receiverName}-${receiverMobile}${receiverTel ? '-' + receiverTel : ''}`,
              logisticsCode,
              printErrorMsg
            }
          })
        },
        fail: () => {
          this.loading = false
        }
      })
    }
  }
}
</script>

<style lang="stylus">
.package-info {
  .el-form-item__label,.el-form-item__content {
    font-size 13px;
    line-height 24px
  }
}
</style>
